const colorsets = {
    a: (_x, _y, v) => {
        let _r = (v/128) * (_x+1)/2;
        let _g = v/128;
        let _b = (v/128) * (_y+1)/2;

        _r = Math.min(_r, 1);
        _g = Math.min(_g, 1);
        _b = Math.min(_b, 1);
        return [_r, _g, _b];
    },
    
    b: (_x, _y, v) => {
        let _r = (v/255) * (_y+1)/2;
        let _g = v/255;
        let _b = v/510;
        return [_r, _g, _b];
    },
    c: (_x, _y, v) => {
        let _r = (_x+1)/2 * (v/255);
        let _g = (_y+1)/2 * (v/255);
        let _b = v/255;
        return [_r, _g, _b];
    },
    d: (_x, _y, v) => {
        let _r = v/255;
        let _g = 0;
        let _b = v/255;
        return [_r, _g, _b];
    },
    v: (_x, _y, v) => {
        const _v = v/255;
        return [_v, _v, _v];
    },
    white: () => {
        return [1,1,1];
    },
    maprgb: (_x, _y, v, r, g, b) => {
        let _r = r / 255;
        let _g = g / 255;
        let _b = b / 255;
        return [_r, _g, _b];
    },
    red: (_x, _y, v) => {
        let _r = v/255;
        let _g = 0;
        let _b = 0;
        return [_r, _g, _b];
    },
    green: (_x, _y, v) => {
        let _r = 0;
        let _g = v/255;
        let _b = 0;
        return [_r, _g, _b];
    },
    blue: (_x, _y, v) => {
        let _r = 0;
        let _g = 0;
        let _b = v/255;
        return [_r, _g, _b];
    },
    yellow: (_x, _y, v) => {
        let _r = v/255;
        let _g = v/255;
        let _b = 0;
        return [_r, _g, _b];
    },

    //top: gold, bottom: blue
    bluegold_y: (_x, _y, v) => {
        const _v = (v/255);
        const _n = (_y+1)/2;
        let _r = _n * _v * 0.8;
        let _g = _n * _v * 0.6;
        let _b = (1 - _n) * _v * 0.8;
        return [_r, _g, _b];
    },

    //front: gold, back: blue
    bluegold_z: (_x, _y, v) => {
        const _v = v/255;
        let _r = _v;
        let _g = _v;
        let _b = 1 - _v;
        return [_r, _g, _b];
    },

    //center gold, back: blue
    bluegold_xy: (_x, _y, v) => {
        const _v = v/255;
        const _n = (1.1 - Math.abs(_x)) * (1.1 - Math.abs(_y));
        let _r = _n * _v;
        let _g = _n * _v;
        let _b = (1 - _n) * _v;
        return [_r, _g, _b];
    },
}

export default colorsets;